/** Two-letter avatar initials from an operator's name, falling back to their email. */
export const initialsOf = (name, email) => {
  const source = (name || email || '?').trim();
  const parts = source.split(/[\s@.]+/).filter(Boolean);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
};
